import React, { useContext } from 'react';
import _ from 'lodash';
import { BreakpointTrackerContext } from '@jutro/layout';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { withRouter } from 'react-router-dom';
import { DatatableUtil } from '@xengage/gw-portals-util-js';
import { DateField } from '@jutro/components';
import metadata from './FormComponent.metadata.json5';
import styles from './FormComponent.module.scss';

function FormComponent(props) {
    const { forms } = props;

    const breakpoint = useContext(BreakpointTrackerContext);
    const { onValidate } = useValidation('FormComponent');

    const getFormTableData = () => _.map(forms, (form) => ({
        formDes: form.formDes,
        formCategory: form.formCategory,
        editionDate: form.editionDate
    }));

    const getCell = (item, _index, property) => item[property.id];

    const getDateCell = (item, index, property) => (
        <div className={styles.unsetFontWeight}>
            <DateField
                id={`${index}EditionDate`}
                value={item[property.id]}
                dataType='object'
                format="mm/dd/yyyy"
                readOnly
            />
        </div>
    )

    const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        tableFormSummary: {
            data: getFormTableData()
        },
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            onValidate,
            getCell,
            sortString: DatatableUtil.sortString,
            sortDate: DatatableUtil.sortDate,
            getDateCell
        }
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );
}

FormComponent.propTypes = wizardProps;
export default withRouter(FormComponent);